module.exports = __webpack_public_path__ + "static/img/322.c321ce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/rjzz/322.jpg
// module id = 5jiA
// module chunks = 0